<template>
  <div class="hero-container" :style="{backgroundImage:'url(' + imageUrl + ')'}">
    <div class="img-container">
      <h1 class="text">
        <span style="font-weight: 300">
          <slot name="normal"></slot>
        </span>
        <br />
        <span v-bind:class="{bold: shouldBeBold}">
          <slot name="bold"></slot>
        </span>
      </h1>
    </div>
  </div>
</template>

<script>
export default {
  name: "HeroSection",
  props: ["imageUrl"],
  computed: {
    shouldBeBold: function() {
      return this.$i18n.locale === "fi" ? false : true;
    }
  }
};
</script>

<style scoped lang="scss">
.hero-container {
  width: 100%;
  height: 40vh;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50%;
  position: relative;
}

.img-container {
  height: 100%;
  background: rgba(0, 0, 0, 0)
    linear-gradient(to top, rgba(0, 0, 0, 0.88) 0%, rgba(0, 0, 0, 0) 35%) repeat
    scroll 0 0;
}

.text {
  z-index: 1;
  text-transform: var(--text-transform);
  color: white;
  font-size: 32px;
  position: absolute;
  bottom: 10px;
  width: 100%;
  margin: 10px 0px;
  font-weight: normal;
}

@media (min-width: $medium) {
  .hero-container {
    height: 50vh;
  }

  .img-container {
    background: rgba(0, 0, 0, 0)
      linear-gradient(to bottom, rgba(0, 0, 0, 0.88) 0%, rgba(0, 0, 0, 0) 35%)
      repeat scroll 0 0;
  }

  .text {
    bottom: unset;
    top: 20px;
    font-size: 48px;
  }
}

@media (min-width: $large) {
  .hero-container {
    position: sticky;
    align-self: flex-start;
    height: 90vh;
    top: 100px;
    flex: 1;
  }

  .text {
    top: 30px;
  }
}
</style>
